<script lang="ts">
  import type { MouseEventHandler } from "svelte/elements";

  import Text from "../Text.svelte";
  import LoadingSpinner from "../LoadingSpinner.svelte";

  export let dataEPId = "";
  export let color = "accent";
  export let title = "";
  export let textSize = "small";
  export let loading = false;
  export let loadingInline = false;
  export let disabled = false;
  export let onClick: MouseEventHandler<HTMLButtonElement> = () => {};

  const DISABLED_MAP: Record<string, string> = {
    ["accent"]: "neutral-02",
    ["dark"]: "neutral-02",
    ["neutral-02"]: "neutral-01",
    ["light"]: "light",
    ["neutral-01"]: "neutral-03",
  };

  const DISABLED_COLOR_MAP: Record<string, string> = {
    ["accent"]: "light",
    ["dark"]: "transparency-dark",
    ["neutral-02"]: "dark",
    ["light"]: "neutral-01",
  };

  const COLOR_MAP: Record<string, string> = {
    ["accent"]: "light",
    ["dark"]: "light",
    ["neutral-02"]: "dark",
    ["light"]: "dark",
    ["neutral-01"]: "dark",
  };
</script>

<button
  style="--button-color: var(--rekki-{color}); --disabled-button-color: var(--rekki-{DISABLED_MAP[
    color
  ]}); --disabled-color: var(--rekki-{DISABLED_COLOR_MAP[
    color
  ]});--text-color: var(--rekki-{COLOR_MAP[color]})"
  {disabled}
  on:click={onClick}
  data-ep-id={dataEPId}
>
  {#if loading}
    <LoadingSpinner light size={10} />
  {:else}
    <div class="container cursor-oversized">
      <Text style="margin: 7.5px 0 6.5px 0;" size={textSize} color={COLOR_MAP[color]}>{title}</Text>
      {#if loadingInline}
        <div class="spin">
          <LoadingSpinner size={10} />
        </div>
      {/if}
    </div>
  {/if}
</button>

<style>
  button {
    display: inline-block;
    box-sizing: border-box;
    flex: 0;
    border-radius: 40px;
    background-color: var(--button-color);
    font-family: "REKKI-OCD";
    padding: 0 12px;
    color: var(--text-color);
    border: 0 none;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  button:disabled {
    background-color: var(--disabled-button-color) !important;
    color: var(--disabled-color);
  }

  button:enabled:active {
    filter: brightness(1.1);
  }

  .spin {
    position: absolute;
    top: 25%;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
